import { User } from "@supabase/supabase-js";

type PasswordResetUser = Pick<User, "app_metadata" | "user_metadata">;

export function canInitiatePasswordReset(user: PasswordResetUser | null): boolean {
  if (!user) {
    return false;
  }

  const providers = user.app_metadata?.providers;
  const hasEmailProvider = Array.isArray(providers)
    ? providers.includes("email")
    : user.app_metadata?.provider === "email";

  if (!hasEmailProvider) {
    return false;
  }

  return !user.user_metadata?.manually_linked_passwordless;
}